// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderBox_wrapper__HeHxu","digits":"OrderBox_digits__Fft+Q","digitsReady":"OrderBox_digitsReady__EBzlI"};